<template>
  <div class="form-section-element">
    <h2 v-show="options.title" class="form-section form-section-primary">{{ options.title }}</h2>
    <div v-show="options.info" class="form-section-info" v-html="options.info"></div>
  </div>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    options: Object,
    default () {
      return {
        title: '',
        subtitle: ''
      }
    }
  },
  data () {
    return {
      isValid: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormSection.vue